import { createContext, type ReactNode, useContext, useMemo } from "react"

import type {
  FeatureFlagConfig,
  FeatureFlagContextValue,
} from "@/shared/types/featureFlags"

import { featureFlagConfig } from "./index"

const FeatureFlagContext = createContext<FeatureFlagContextValue>({
  isEnabled: () => false,
  flags: {},
})

export interface FeatureFlagProviderProps {
  children: ReactNode
  overrideFlags?: FeatureFlagConfig
}

export const FeatureFlagProvider = ({
  children,
  overrideFlags,
}: FeatureFlagProviderProps) => {
  const value = useMemo<FeatureFlagContextValue>(() => {
    const flags: FeatureFlagConfig = overrideFlags ?? featureFlagConfig
    return {
      flags,
      isEnabled: (key: string) => flags[key] === true,
    }
  }, [overrideFlags])

  return (
    <FeatureFlagContext.Provider value={value}>
      {children}
    </FeatureFlagContext.Provider>
  )
}

export const useFeatureFlagContext = (): FeatureFlagContextValue =>
  useContext(FeatureFlagContext)
